/* eslint-disable max-classes-per-file */
import { MClassification } from '../classification.model'

export class MSafeStorageFile {
    fileId: string

    fileUrl: string

    referenceId: string

    sequence: number

    type: string

    constructor(file: MSafeStorageFile) {
        this.fileId = file?.fileId
        this.fileUrl = file?.fileUrl
        this.referenceId = file?.referenceId
        this.sequence = file?.sequence
        this.type = file?.type
    }
}

export class MSafeStorage {
    make: string

    model: string

    safeType: string

    serialCode: string

    storageId: string

    files: MSafeStorageFile

    constructor(safeStorage: ISafeStorage) {
        this.make = safeStorage?.make?.code
        this.model = safeStorage?.model?.code
        this.safeType = safeStorage?.safeType?.code
        this.serialCode = safeStorage?.serialCode
        this.storageId = safeStorage?.id
        this.files = safeStorage?.files?.[0]
    }
}

export interface ISafeStorage {
    createdAt?: string
    createdBy?: string
    id: string
    make: MClassification
    model: MClassification
    safeType: MClassification
    serialCode: string
    status?: string
    updatedAt?: string
    updatedBy?: string
    userId?: string
    files: MSafeStorageFile[]
}

export interface MSafeStorageReducer {
    safeStorages: MSafeStorage[]
}
